import { createContext, useContext } from "react";

import type { FilterSet } from "@skilitics/designer-ui-components";
import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import type { Ordering, OrderingDirection, View } from "./types.ts";

export type LandingPageSettings = {
  view: View;
  ordering: Ordering;
  orderingDirection: OrderingDirection;
  filterSets: FilterSet<InteractModuleListItem>[];
  isSuperUser: boolean;
  devFetchAllUsersModules: boolean;
  setDevFetchAllUsersModules: (value: boolean) => void;
};

export type FilterSetOptions = {
  replace: boolean;
};

type LandingPageSettingsContext = LandingPageSettings & {
  setView: (view: View) => void;
  setOrdering: (ordering: Ordering) => void;
  setOrderingDirection: (orderingDirection: OrderingDirection) => void;
  hasFilterSet: (id: FilterSet<InteractModuleListItem>["id"]) => boolean;
  getFilterSet: (id: FilterSet<InteractModuleListItem>["id"]) => FilterSet<InteractModuleListItem> | undefined;
  addFilterSet: (filterSet: FilterSet<InteractModuleListItem>, options?: FilterSetOptions) => void;
  removeFilterSet: (id: FilterSet<InteractModuleListItem>["id"]) => void;
};

export const LandingPageSettingsContext = createContext<LandingPageSettingsContext | undefined>(undefined);

export const useLandingPageSettings = (): LandingPageSettingsContext => {
  const context = useContext(LandingPageSettingsContext);

  if (!context) throw new Error(`Expected LandingPageSettingsContext in ancestor tree.`);

  return context;
};

LandingPageSettingsContext.displayName = "LandingPageSettingsContext";
